import { render, staticRenderFns } from "./main-hospital-panel.vue?vue&type=template&id=95726732&scoped=true"
import script from "./main-hospital-panel.vue?vue&type=script&lang=js"
export * from "./main-hospital-panel.vue?vue&type=script&lang=js"
import style0 from "./main-hospital-panel.vue?vue&type=style&index=0&id=95726732&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95726732",
  null
  
)

export default component.exports